import { render, staticRenderFns } from "./participant-app-notifications.vue?vue&type=template&id=5f5da346&scoped=true&"
import script from "./participant-app-notifications.vue?vue&type=script&lang=js&"
export * from "./participant-app-notifications.vue?vue&type=script&lang=js&"
import style0 from "./participant-app-notifications.vue?vue&type=style&index=0&id=5f5da346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5da346",
  null
  
)

component.options.__file = "participant-app-notifications.vue"
export default component.exports